import './App.css';

function App() {
  /*
  return (
    <Provider store={store}>
      <div className="App">
        <header className="App-header">
          <h1>Google Drive File Picker with React & Redux</h1>
          <GoogleDrivePicker />
        </header>

        <footer className="App-footer">
          <a
            href="/terms-of-service.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms of Service
          </a>
          <span>|</span>
          <a
            href="/privacy-policy.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
        </footer>
      </div>
    </Provider>
  );
  */
 return (
  <div className="App">
      <iframe
        src="/landing.html"
        title="My External HTML Page"
        style={{ width: '100%', height: '100vh', border: 'none' }}
      />
    </div>
 )
}

export default App;